var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstCardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.33325C20.5983 8.33325 21.0914 8.78363 21.1588 9.36386L21.1667 9.49992L21.1671 11.0329C25.2277 11.5562 28.4444 14.7732 28.9672 18.834L30.5 18.8333C31.1443 18.8333 31.6667 19.3556 31.6667 19.9999C31.6667 20.5982 31.2163 21.0913 30.6361 21.1587L30.5 21.1666L28.967 21.167C28.4438 25.2272 25.2273 28.4437 21.1671 28.967L21.1667 30.4999C21.1667 31.1443 20.6443 31.6666 20 31.6666C19.4017 31.6666 18.9086 31.2162 18.8412 30.636L18.8333 30.4999L18.8341 28.9671C14.7733 28.4443 11.5562 25.2276 11.033 21.167L9.49999 21.1666C8.85566 21.1666 8.33333 20.6442 8.33333 19.9999C8.33333 19.4016 8.78371 18.9085 9.36394 18.8411L9.49999 18.8333L11.0328 18.834C11.5556 14.7728 14.7729 11.5556 18.8341 11.0327L18.8333 9.49992C18.8333 8.85559 19.3557 8.33325 20 8.33325ZM20 13.2916C16.2951 13.2916 13.2917 16.295 13.2917 19.9999C13.2917 23.7048 16.2951 26.7083 20 26.7083C23.7049 26.7083 26.7083 23.7048 26.7083 19.9999C26.7083 16.295 23.7049 13.2916 20 13.2916ZM20 15.3333C22.5773 15.3333 24.6667 17.4226 24.6667 19.9999C24.6667 22.5772 22.5773 24.6666 20 24.6666C17.4227 24.6666 15.3333 22.5772 15.3333 19.9999C15.3333 17.4226 17.4227 15.3333 20 15.3333Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstCardImage);
export default __webpack_public_path__ + "static/media/first-card-image.6090fc6e7bee2454d2b550a86c67c0a0.svg";
export { ForwardRef as ReactComponent };